const iconNames = [
  "create",
  "basic",
  "custom",
  "daily",
  "fiction",
  "historical",
  "legal",
  "number",
  "pm",
  "screenplay",
  "weekly",

  "calendarToday",
  "calendarCheck",
  "calendarRoutine",
  "calendarStar",
  "calendarSchedule",

  "books",
  "writing",
  "notebook",
  "planDocument",
  "moneyChart",
  "documentPen",
  "lineChart",
  "briefcase",
  "pieChart",
  "flowchart",
  "userFlow",
  "shopping",
  "stationary",
  "sitemap",
  "website",
  "webdesign",
  "feedback",
  "social",
  "appPencil",

  "ideaMan",
  "pencilCreative",
  "pencilRuler",
  "drawingTablet",
  "lightbulb",
  "camera",
  "pictures",
  "art",

  "filmTemplate",
  "talking",
  "play",
  "theatre",

  "scalesOfJustice",
  "judgeGavel",
  "workplaceLaw",
  "testify",
  "familyLaw",
  "trial",

  "familyTree",
  "boy",
  "girl",
  "love",
  "loveTriangle",
  "lovers",
  "loveMessage",
  "loveMan",
  "divorce",
  "couple",

  "wallet",
  "bank",
  "safe",

  "globe",
  "journey",
  "mountainrace",
  "hotAirBalloon",
  "anchor",
  "beach",
  "mountains",
  "landscape",
  "crane",
  "city",
  "castle",
  "tajMahal",
  "futureCity",
  "cottage",
  "manor",
  "plane",
  "van",
  "taxi",
  "bulletTrain",
  "train",
  "tram",

  "chess",
  "dice",
  "cards",
  "medal",

  "tea",
  "groceries",
  "dining",
  "martini",

  "rocket",
  "satellite",
  "solarSystem",
  "spaceStation",
  "astronaut",
  "ufo",

  "beakers",
  "medical",
  "vase",
  "museumCrown",
  "fossil",
  "sarcophagus",
  "cannon",
  "armour",
  "crossedSwords",

  "murderKnife",
  "gun",
  "western",
  "bowAndArrow",
  "unicorn",
  "wizard",
  "mermaid",

  "ferrisWheel",
  "magic",
  "circus",

  "flower",
  "butterfly",
  "rose",

  "gemstone",
  "ballet",
  "disco"
];

export default iconNames;
